import React, { useState } from 'react';
import { i18nIntl } from '../../../lib/ep';
import { injectIntl } from 'react-intl';
import transferPlaceholder from '../../../hoc/transferPlaceholder';

import { SecondaryButton } from '../../builder/ActionButton';
import ActionLink from '../../builder/ActionLink';
import ButtonCollection from '../../builder/ButtonCollection';
import Checkbox from '../../builder/Checkbox';
import DisabledArea from '../../builder/DisabledArea';
import Input from '../../builder/Input';
import Model from '../../builder/Model';
import RichEditor from '../../builder/RichEditor';
import SectionTitle from '../../builder/SectionTitle';
import SectionSubtitle from '../../builder/SectionSubtitle';
import SaveButton from '../../builder/SaveButton';
import FloatingLayer from '../../builder/FloatingLayer';

const RichPlaceHolder = injectIntl(transferPlaceholder(RichEditor));

const PasswordProtected = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const is_spanish = window?.is_spanish ?? false;

	const [ promotion, setPromotion ] = useState(props?.promotion ?? false);
	const [ errors, setErrors ] = useState({});

	if(!promotion) {
		return (
			<div class="without_actions">{i18n("Unexpected error.")}</div>
		)
	}

	const change = (k, v) => {
		let _promotion = { ...promotion };
		let _errors = {};
		if(k == 'password_promo' && v.trim() == '') {
			_errors.password_promo = "This field cannot be left empty";
		}
		_promotion[k] = v;
		setPromotion(_promotion);
		setErrors(_errors);
	};

	const save = (cb) => {
		const fields = {
			password_enable:promotion.password_enable,
			password_promo:promotion.password_promo,
			password_desc:promotion.password_desc,
		}
		$.post(`/promotions/password/${promotion.id}`, fields, (res) => {
			if(props.onToggle != undefined) props.onToggle(promotion.password_enable);
			if(cb != undefined) cb();
		});
	};

	const is_enabled = (promotion.password_enable === true || promotion.password_enable == '1') ? true : false;

	const has_errors = (Object.keys(errors).length > 0) ? true : false;

	return (
		<FloatingLayer _class={{size:'small'}} backButton={props.backButton}>
			<div>
				<div class="gui_section_header alone_section_header cleared_header">
					<SectionTitle _class={{other:'in_top'}}>Password protection</SectionTitle>

					{(is_enabled) && (
						<ButtonCollection>
							<SecondaryButton
								icon='knk-preview'
								_href={`/promotions/protected_promo/${promotion.id}`}
								_target="_blank"
							>Preview</SecondaryButton>
						</ButtonCollection>
					)}
				</div>

				<SectionSubtitle autotranslate={false}>{(!is_spanish) ? "This option enables the display of the password protection screen. To access, view and participate in the promotion, the user first must enter the password on this screen. Set the password and the customization options for the protection screen here." : "Esta opción activa la pantalla de protección con contraseña. Para acceder, visualizar y participar en la promoción, el usuario primero deberá introducir la contraseña en esta pantalla. Configura aquí la contraseña y las opciones de personalización de la pantalla de protección."} <ActionLink _href={`${window.zendesk_base_url}207884866`} _target="_blank">More information</ActionLink></SectionSubtitle>

				<Model model={promotion} change={change}>
					<Checkbox
						name="password_enable"
						value={is_enabled}
					>Enable password protection</Checkbox>
				</Model>

				<DisabledArea _class={{other:'not_in_top'}} disabled={!is_enabled}>
					<Model model={promotion} change={change} errors={errors}>
						<Input
							name="password_promo"
							_class={{size:60, first:true}}
						>Password</Input>

						<RichPlaceHolder
							name="password_desc"
							placeholder={i18n("Enter the password to access the promotion")}
						>Introductory text</RichPlaceHolder>
					</Model>
				</DisabledArea>

				<ButtonCollection in_floating={true}>
					<SaveButton
						onClick={(e, cb) => save(cb)}
						disabled={has_errors}
					>Save changes</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
};

export default injectIntl(PasswordProtected);